import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CreateProductCard } from "@/components/CreateProductCard";
import { useState } from "react";
import { PricingModal } from "@/components/PricingModal";
interface Product {
  id: string;
  name: string;
  description: string;
  link: string;
  logo: string;
  product_screen?: string;
  features?: string;
}
interface ProductGridProps {
  products: Product[];
  isAdmin: boolean;
}
export const ProductGrid = ({
  products,
  isAdmin
}: ProductGridProps) => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const handleProductClick = (product: Product) => {
    console.log('Product clicked:', product);
    setSelectedProduct(product);
    setShowPricingModal(true);
  };
  return <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 rounded-full">
        {products.map(product => <Card key={product.id} className="flex flex-col p-6 hover:shadow-sm transition-shadow bg-white rounded-2xl border-0">
            {product.product_screen && <div className="w-full mb-4">
                <img src={product.product_screen} alt={`${product.name} screenshot`} className="w-full object-cover rounded-lg mb-4" />
              </div>}
            
            <div className="text-gray-600 mb-4" dangerouslySetInnerHTML={{
          __html: product.description
        }} />
            
            <div className="flex justify-start mt-auto">
              <Button onClick={() => handleProductClick(product)} style={{
            backgroundColor: '#008169',
            color: 'white'
          }} className="px-8 rounded-full text-white bg-[#008169]">
                Berlangganan
              </Button>
            </div>
          </Card>)}
      </div>
      <PricingModal isOpen={showPricingModal} onClose={() => setShowPricingModal(false)} selectedPath={selectedProduct?.link || ''} productId={selectedProduct?.id} />
    </>;
};